<script setup lang="ts">
onMounted(() => {
  document.body.classList.add('webview-layout')
})
</script>

<template>
  <div class="min-h-screen container" data-layout="webview">
    <NuxtPage class="" />
  </div>
</template>

<style scoped lang="scss" />
